import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'Components';
import './Modal.css';

const Modal = (props) => {
  if (!props.show) return null;

  return (
    <div className={`modal ${props.className}`} style={props.style} >
      { props.children }
      { props.showClose &&
      <Button className="modal__button" onClick={props.onClose} >
        Close
      </Button>
      }
    </div>
  );
};

Modal.propTypes = {
  onClose: PropTypes.func,
  show: PropTypes.bool,
  showClose: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.shape({}),
};

Modal.defaultProps = {
  onClose: () => null,
  style: {},
  show: false,
  showClose: false,
  children: null,
  className: '',
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.jsx